import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageUserActivityLog from '@/pages/account/activity-log'

export const Route = createFileRoute('/app/account/activity-log/$')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageUserActivityLog />
}
